import { Document, DocumentHealthStats } from './types';

export function calculateHealthStats(documents: Document[]): DocumentHealthStats {
  const total = documents.length;
  const cleared = documents.filter(d => d.status === 'cleared').length;
  const pending = documents.filter(d => d.status === 'pending').length;
  const blocking = documents.filter(d => d.status === 'blocking').length;

  const blockedShipments = new Set(
    documents
      .filter(d => d.status === 'blocking' && d.blockedEntities)
      .flatMap(d => d.blockedEntities || [])
  );

  return {
    total,
    cleared,
    pending,
    blocking,
    shipmentsBlocked: blockedShipments.size,
  };
}